import { createInsightType, deleteInsightType, getAllInsightTypes, saveOrderInsightType, updateInsightType } from "features/library/reducer/LibraryActions";
import { currentWorkspaceId } from "index";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { findWorkspaceById } from "redux/memoizedSelectors";
import DragDrop, { SetItemsProps } from "shared/Drag-Drop/DragDrop";
import { CustomizationColors } from "shared/ui-basics";
import { CustomBreadCrumb } from "shared/ui-basics/ui-components/CustomBreadCrumb";
import { EMPTY_GUID, getRandomInt } from "utils/helpers";
import TaxonomyCreateItem from "../components/TaxonomyCreateItem";
import TaxonomyListItem from "../components/TaxonomyListItem";
import { Body, Container, Header, RecordsContainer, Wrapper } from "./style";
import DataLoader from "shared/components/data-loader";

const TaxonomyInsightType: React.FC = () => {
	const { t } = useTranslation();

	const currentWorkspace = useSelector(findWorkspaceById(currentWorkspaceId));
	const insightTypes = useSelector((state: any) => state.libraries.insightTypes);
	const colors = Object.keys(CustomizationColors);

	const onCreate = ({ name }: { name: string }) => {
		createInsightType({ 
			newInsightType: { id: EMPTY_GUID, name: name?.truncate(100, true), colorCode: colors[getRandomInt(0, colors.length - 1)] } 
		});
	}
	const onUpdate = ({ updatedItem, modifiedAttribNames }: { updatedItem: any; modifiedAttribNames: string[] }) => {
		updateInsightType({ item: updatedItem, modifiedAttribNames });
	}

	const onDelete = ({ item }: { item: any }) => {
		const typeId = localStorage.getItem("lastUsedInsightTypeId");
		if (typeId === item.id) {
			localStorage.removeItem("lastUsedInsightTypeId");
		}
		deleteInsightType({ id: item.id });
	};

	const onDragEnd = ({ newItems }: SetItemsProps) => saveOrderInsightType({ ids: newItems?.map((el) => el.id)?.join("|") });

	return (
		<DataLoader asyncFns={[{ asyncFn: getAllInsightTypes, parameter: { checkIsUsed: true } }] as any}>
			<Container>
				<Header>
					<CustomBreadCrumb paths={[currentWorkspace?.name, t("TAXONOMY"), t("INSIGHT_TYPE")] as any} />
				</Header>
				<Body>
					<Wrapper>
						<div className={"f24-title mb-4"}>{t("INSIGHT_TYPE")}</div>
						<TaxonomyCreateItem onCreate={onCreate} />
						<RecordsContainer>
							<DragDrop items={insightTypes} setItems={onDragEnd} orientation="vertical">
								{(item) => <TaxonomyListItem key={item.id} item={item} onUpdate={onUpdate} onDelete={onDelete} isEditAllowed={item?.isCustom} />}
							</DragDrop>
						</RecordsContainer>
					</Wrapper>
				</Body>
			</Container>
		</DataLoader>
	);
};

export default TaxonomyInsightType;
